export default __webpack_public_path__ + "static/media/logo.232bdf43.png";